import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "review-view-container" }
const _hoisted_2 = { class: "review-view-header" }
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = { class: "header-actions" }
const _hoisted_5 = { class: "review-view-content" }

import { nextTick } from "vue";
import AIAssistantSummary from "./AIAssistantSummary.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AIAssistantReviewView',
  props: {
  sessionData: {
    type: Object,
    required: true,
  },
  isMinimized: {
    type: Boolean,
    default: false,
  },
  displayMode: {
    type: String as () => "widget" | "modal",
    default: "widget",
  },
  position: {
    type: String as () => "left" | "right",
    default: "right",
  },
},
  emits: [
  "expand",
  "minimize",
  "collapse",
  "review-saved",
  "session-discarded",
],
  setup(__props, { emit: __emit }) {

/**
 * AIAssistantReviewView.vue - Review State Wrapper
 * 
 * Wrapper for the review_ready state that handles widget/modal positioning.
 * Contains AIAssistantSummary internally for the actual review UI.
 * 
 * Features:
 * - Widget mode: positioned bottom-right corner
 * - Modal mode: centered on screen
 * - Header with expand/minimize/close buttons
 * - Passes events up to parent orchestrator
 */
const props = __props;

const emit = __emit;

const onExpand = () => {
  emit("expand");
};

const onMinimize = () => {
  emit("minimize");
};

const onCollapse = () => {
  emit("collapse");
};

const onReviewSaved = () => {
  emit("review-saved");
};

// Use nextTick to prevent "emitsOptions" error when component unmounts during emit
const onSessionDiscarded = () => {
  nextTick(() => {
    emit("session-discarded");
  });
};

return (_ctx: any,_cache: any) => {
  const _component_w_icon = _resolveComponent("w-icon")!
  const _component_w_icon_button = _resolveComponent("w-icon-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["review-view", [__props.displayMode, __props.position]])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_w_icon, {
            name: "smart",
            size: 24,
            class: "noa-icon"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "review-title" }, "NOA Notes", -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          (__props.displayMode === 'widget')
            ? (_openBlock(), _createBlock(_component_w_icon_button, {
                key: 0,
                "icon-name": "minus",
                type: "button",
                class: "icon-actions",
                onClick: onMinimize
              }))
            : _createCommentVNode("", true),
          (__props.displayMode === 'widget')
            ? (_openBlock(), _createBlock(_component_w_icon_button, {
                key: 1,
                "icon-name": "open-in-full",
                type: "button",
                class: "icon-actions",
                onClick: onExpand
              }))
            : _createCommentVNode("", true),
          (__props.displayMode === 'modal')
            ? (_openBlock(), _createBlock(_component_w_icon_button, {
                key: 2,
                "icon-name": "minus",
                type: "button",
                class: "icon-actions",
                onClick: onMinimize
              }))
            : _createCommentVNode("", true),
          (__props.displayMode === 'modal')
            ? (_openBlock(), _createBlock(_component_w_icon_button, {
                key: 3,
                "icon-name": "close-full",
                type: "button",
                class: "icon-actions",
                onClick: onCollapse
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(AIAssistantSummary, {
          "initial-context": __props.sessionData,
          "parent-summary-status": 'ready',
          onReviewSaved: onReviewSaved,
          onSessionDiscarded: onSessionDiscarded,
          onClose: onMinimize
        }, null, 8, ["initial-context"])
      ])
    ], 2)
  ]))
}
}

})